import React from 'react';
import ProjectLayout from '../Components/ProjectLayout';

import heroMapImg from '../assets/projects/adare-collection/hero-map.jpg';
import propertyGridImg from '../assets/projects/adare-collection/property-grid.jpg';
import propertyDetailImg from '../assets/projects/adare-collection/property-detail.jpg';
import enquiryFormImg from '../assets/projects/adare-collection/enquiry-form.jpg';

const AdareCollection = () => {
  return (
    <ProjectLayout
      title="The Adare Collection"
      description={[
        'Sole web designer for The Adare Collection, luxury private rentals near Adare Manor for Ryder Cup 2027. I own the brand on the web end to end: visual system, property pages, enquiry flow, SEO, performance, and shipping when new houses come online.',
        'One property template drives the homepage grid, listings, detail pages, map pins and enquiry picker. The site has to feel high-end and convert serious commercial enquiries, not look like a listing portal.',
        <>
          Live at{' '}
          <a
            href="https://theadarecollection.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            theadarecollection.com
          </a>
        </>,
      ]}
      credits={['Design', 'Web', 'SEO', 'Lead Gen']}
    >
      <div className="pm-section">
        <h2 className="pm-section__title">Hero & proximity</h2>
        <hr className="pm-section__rule" />
        <p className="pm-section__copy">
          A split hero pairs estate photography and a countdown with an interactive
          map and walk-radius, so the first screen sells the dream and answers
          “how close am I to the course?”
        </p>
      </div>
      <img
        className="pm-full"
        src={heroMapImg}
        alt="The Adare Collection homepage split hero with golf photography and interactive property map"
      />

      <div className="pm-section">
        <h2 className="pm-section__title">One template, many houses</h2>
        <hr className="pm-section__rule" />
        <p className="pm-section__copy">
          Add a house to the properties model with gallery, specs, map pin and tier
          badge, and it appears across the grid, listings, detail page and enquiry
          picker. Shared cards and Executive / Premium / Deluxe badges keep the luxury
          bar consistent as the portfolio grows past twenty properties.
        </p>
      </div>
      <img
        className="pm-full"
        src={propertyGridImg}
        alt="Our Collection property grid with Executive tier badges"
      />

      <div className="pm-section">
        <h2 className="pm-section__title">Property pages</h2>
        <hr className="pm-section__rule" />
        <p className="pm-section__copy">
          Every listing uses the same detail template: gallery, availability, map and
          a clear path to enquire. New houses ship through a documented workflow for
          images, data, map, sitemap and SEO, so house fourteen is the same process as
          house thirteen.
        </p>
      </div>
      <img
        className="pm-full"
        src={propertyDetailImg}
        alt="Range View property detail page with gallery and request availability"
      />

      <div className="pm-section">
        <h2 className="pm-section__title">Qualified enquiries</h2>
        <hr className="pm-section__rule" />
        <p className="pm-section__copy">
          Success is qualified leads, not page views alone. The form asks group size,
          budget, intended use and preferred homes so the team can filter tyre-kickers
          and respond with the right house.
        </p>
      </div>
      <img
        className="pm-full"
        src={enquiryFormImg}
        alt="Contact request form with guest count, budget and property preferences"
      />
    </ProjectLayout>
  );
};

export default AdareCollection;
